const sign_up_and_sign_in = {
    identifiers_email: 'عنوان البريد الإلكتروني',
    identifiers_phone: 'رقم الهاتف',
    identifiers_username: 'اسم المستخدم',
    identifiers_email_or_sms: 'عنوان البريد الإلكتروني أو رقم الهاتف',
    identifiers_none: 'غير مطبق',
    and: 'و',
    or: 'أو',
    sign_up: {
        title: 'التسجيل',
        sign_up_identifier: 'معرف التسجيل',
        identifier_description: 'جميع معرّفات التسجيل المحددة مطلوبة عند إنشاء حساب جديد.',
        sign_up_authentication: 'إعدادات المصادقة للتسجيل',
        verification_tip: 'يجب على المستخدمين التحقق من البريد الإلكتروني أو رقم الهاتف الذي قمت بتكوينه عن طريق إدخال رمز التحقق أثناء التسجيل.',
        authentication_description: 'سيكون على المستخدمين إكمال جميع الإجراءات المحددة في التدفق.',
        set_a_password_option: 'إنشاء كلمة المرور الخاصة بك',
        verify_at_sign_up_option: 'التحقق عند التسجيل',
        social_only_creation_description: '(ينطبق هذا على إنشاء الحساب الاجتماعي فقط)',
        collect_user_profile: 'جمع ملف تعريف المستخدم',
        add_profile_fields: 'إضافة حقول الملف الشخصي',
        profile_fields_hint: {
            not_in_list: 'غير موجود في القائمة؟',
            set_up: 'إعداد',
            go_to: 'حقول الملف الشخصي الأخرى الآن.',
        },
    },
    sign_in: {
        title: 'تسجيل الدخول',
        sign_in_identifier_and_auth: 'معرف وإعدادات المصادقة لتسجيل الدخول',
        description: 'يمكن للمستخدمين تسجيل الدخول باستخدام أي من الخيارات المتاحة. قم بضبط التخطيط عن طريق سحب وإسقاط الخيارات أدناه.',
        add_sign_in_method: 'إضافة طريقة تسجيل الدخول',
        add_sign_up_method: 'إضافة طريقة التسجيل',
        password_auth: 'كلمة المرور',
        verification_code_auth: 'رمز التحقق',
        auth_swap_tip: 'قم بتبديل الخيارات أدناه لتحديد الظهور الأول في التدفق.',
        require_auth_factor: 'يجب عليك تحديد عامل مصادقة واحد على الأقل.',
        forgot_password: 'نسيت كلمة المرور',
        forgot_password_description: 'يمكن للمستخدمين إعادة تعيين كلمة المرور الخاصة بهم باستخدام أي طريقة تحقق متاحة.',
        add_verification_method: 'إضافة طريقة تحقق',
        email_verification_code: 'رمز التحقق من البريد الإلكتروني',
        phone_verification_code: 'رمز التحقق من الهاتف',
    },
    social_sign_in: {
        title: 'تسجيل الدخول الاجتماعي',
        social_sign_in: 'تسجيل الدخول الاجتماعي',
        description: 'اعتمادًا على المعرف الإلزامي الذي قمت بإعداده ، قد يُطلب من المستخدم تقديم معرف عند التسجيل باستخدام موصل اجتماعي.',
        add_social_connector: 'إضافة موصل اجتماعي',
        set_up_hint: {
            not_in_list: 'غير مدرج؟',
            set_up_more: 'إعداد',
            go_to: 'موصلات اجتماعية أخرى الآن.',
        },
        settings_title: 'تجربة تسجيل الدخول الاجتماعي',
        automatic_account_linking: 'ربط الحسابات تلقائيًا بنفس المعرف',
        automatic_account_linking_tip: 'عند التمكين، إذا قام المستخدم بتسجيل الدخول بهوية اجتماعية جديدة وكان هناك حساب موجود بنفس المعرف (مثل عنوان البريد الإلكتروني)، فسيقوم Logto بربط الهوية الاجتماعية تلقائيًا بهذا الحساب. لن يُطلب من المستخدم اختيار ربط الحسابات.',
        required_sign_up_identifiers: 'مطالبة المستخدمين بتقديم معرّف التسجيل الناقص',
        required_sign_up_identifiers_tip: 'عند التمكين، يجب على المستخدمين الذين يسجلون الدخول عبر مزودي الخدمة الاجتماعية ملء أي معرف تسجيل ناقص (مثل البريد الإلكتروني) قبل إكمال تسجيل الدخول. \n\nإذا تم تعطيله، يمكن للمستخدمين المتابعة دون تقديم المعرفات الناقصة، حتى إذا لم يقم الحساب الاجتماعي بمزامنتها.',
    },
    passkey_sign_in: {
        title: 'تسجيل الدخول بمفتاح المرور',
        passkey_sign_in: 'تسجيل الدخول بمفتاح المرور',
        enable_passkey_sign_in_description: 'السماح للمستخدمين بالوصول السريع والآمن إلى التطبيق عبر مفتاح المرور (WebAuthn)، باستخدام القياسات الحيوية أو مفتاح الأمان وما إلى ذلك.',
        prompts: 'مطالبات مفتاح المرور',
        show_passkey_button: 'إظهار زر "المتابعة بمفتاح المرور" في صفحة تسجيل الدخول',
        show_passkey_button_tip: 'تعطيل زر "المتابعة بمفتاح المرور" يجعل تدفق تسجيل الدخول يعتمد على المعرف أولاً، مع عرض خيارات كلمة المرور ومفتاح المرور في الخطوة التالية.',
        allow_autofill: 'السماح بالمطالبة والملء التلقائي لمفاتيح المرور المسجلة في حقول المعرف',
    },
    tip: {
        set_a_password: 'مجموعة فريدة من كلمة المرور لاسم المستخدم الخاص بك ضرورية.',
        verify_at_sign_up: 'ندعم حاليًا التحقق من البريد الإلكتروني الموثوق. قد يحتوي قاعدة المستخدمين الخاصة بك على عدد كبير من عناوين البريد الإلكتروني ذات جودة منخفضة إذا لم يتم التحقق.',
        password_auth: 'هذا أمر ضروري حيث قمت بتمكين خيار إنشاء كلمة مرور أثناء عملية التسجيل.',
        verification_code_auth: 'هذا أمر ضروري حيث قمت بتمكين خيار تقديم رمز التحقق عند التسجيل. يمكنك إلغاء التحديد عند السماح بإعداد كلمة المرور في عملية التسجيل.',
        email_mfa_enabled: 'رمز التحقق من البريد الإلكتروني ممكّن بالفعل للمصادقة المتعددة العوامل (MFA)، لذلك لا يمكن إعادة استخدامه كطريقة تسجيل دخول أولية للأمان.',
        phone_mfa_enabled: 'رمز التحقق من الهاتف ممكّن بالفعل للمصادقة المتعددة العوامل (MFA)، لذلك لا يمكن إعادة استخدامه كطريقة تسجيل دخول أولية للأمان.',
        delete_sign_in_method: 'هذا أمر ضروري حيث قمت باختيار {{identifier}} كمعرف مطلوب.',
        password_disabled_notification: 'تم تعطيل خيار "إنشاء كلمة مرورك" لتسجيل اسم المستخدم، مما قد يمنع المستخدمين من تسجيل الدخول. قم بالتأكيد للمتابعة بالحفظ.',
    },
    advanced_options: {
        title: 'خيارات متقدمة',
        enable_single_sign_on: 'تمكين تسجيل الدخول الموحد للمؤسسة (SSO)',
        enable_single_sign_on_description: 'تمكين المستخدمين من تسجيل الدخول إلى التطبيق باستخدام تسجيل الدخول الموحد مع هوياتهم في المؤسسة.',
        single_sign_on_hint: {
            prefix: 'انتقل إلى ',
            link: '"تسجيل الدخول الموحد للمؤسسة"',
            suffix: 'لمزيد من إعدادات الموصلات في المؤسسة.',
        },
        show_sso_branding_before_email_match: 'إظهار أسماء وشعارات موصلات SSO قبل تطابق نطاق البريد الإلكتروني',
        show_sso_branding_before_email_match_description: 'عند التفعيل، يتم تضمين أسماء وشعارات موصلات SSO في تكوين تسجيل الدخول العام قبل تطابق نطاق البريد الإلكتروني. عند الإيقاف، لا تظهر إلا بعد التطابق.',
        enable_user_registration: 'تمكين تسجيل المستخدم',
        enable_user_registration_description: 'تمكين أو تعطيل تسجيل المستخدم. بمجرد تعطيله ، يمكن للمستخدمين ما زالوا يتم إضافتهم في وحدة التحكم الإدارية ولكن المستخدمين لم يعد بإمكانهم إنشاء حسابات من خلال واجهة تسجيل الدخول.',
        unknown_session_redirect_url: 'رابط إعادة توجيه الجلسة غير المعروفة',
        unknown_session_redirect_url_tip: 'في بعض الأحيان ، قد لا يتعرف Logto على جلسة المستخدم على صفحة تسجيل الدخول ، مثل عندما تنتهي الجلسة أو عندما يحفظ المستخدم رابط تسجيل الدخول أو يشاركه. بشكل افتراضي ، يظهر خطأ “جلسة غير معروفة” 404. لتعزيز تجربة المستخدم ، قم بتعيين عنوان URL احتياطي لإعادة توجيه المستخدمين إلى تطبيقك وبدء المصادقة من جديد.',
    },
    username_policy: {
        title: 'سياسة اسم المستخدم',
        description: 'خصّص متطلبات اسم المستخدم، بما في ذلك الطول والأحرف المسموح بها وحساسية حالة الأحرف.',
        manage_button: 'إدارة',
        modal_title: 'سياسة اسم المستخدم',
        modal_description: 'خصّص متطلبات اسم المستخدم للمستخدمين النهائيين لديك.',
        length: {
            title: 'طول اسم المستخدم',
            minimum: 'الحد الأدنى',
            maximum: 'الحد الأقصى',
            min_greater_than_max: 'لا يمكن أن يكون الحد الأدنى للطول أكبر من الحد الأقصى للطول.',
        },
        allowed_chars: {
            title: 'أنواع الأحرف المسموح بها',
            uppercase: 'الأحرف الكبيرة (A-Z)',
            lowercase: 'الأحرف الصغيرة (a-z)',
            numbers: 'الأرقام (0-9)',
            underscore: 'الشرطات السفلية (_)',
            no_valid_leading_char: 'لا يُسمح بالأرقام وحدها. فعّل واحدًا على الأقل من الأحرف الكبيرة أو الصغيرة أو الشرطات السفلية.',
            no_char_selected: 'اختر نوع حرف واحد على الأقل.',
        },
        case_sensitive: {
            title: 'أسماء المستخدمين الحساسة لحالة الأحرف',
            description: 'التعامل مع الأحرف الكبيرة والصغيرة على أنها مختلفة. تتم معاملة ‘user123’ و‘User123’ كاسمي مستخدم مختلفين.',
        },
        case_conflicts: {
            title: 'تم اكتشاف تعارضات في أسماء المستخدمين الحالية',
            description: 'ستتعارض بعض أسماء المستخدمين إذا تم إيقاف حساسية حالة الأحرف. حل مجموعات التعارض {{count}} أدناه قبل الحفظ.',
            sample_title: 'أسماء المستخدمين المتعارضة',
        },
    },
};
export default Object.freeze(sign_up_and_sign_in);
